export const ActionLogType = {
  CREDITOR_DEBTOR_CREATION_ABORTED: 'creditor-aborted-debtor-creation'
};
